import { render } from "./TeamMembersOverview.vue?vue&type=template&id=c9c9be6a&scoped=true&ts=true"
import script from "./TeamMembersOverview.vue?vue&type=script&lang=ts"
export * from "./TeamMembersOverview.vue?vue&type=script&lang=ts"

import "./TeamMembersOverview.vue?vue&type=style&index=0&id=c9c9be6a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c9be6a"]])

export default __exports__